module.exports = __webpack_public_path__ + "img/left_bg.c2521f0.png";